export const ACCESS_STORAGE_KEY = 'selected_access_context';

export const fallbackAccessOptions = (role) => {
  if (role === 'gestor') {
    return [
      { key: 'gestor', label: 'Gestor Global', description: 'Igrejas, módulos, grupos e visão geral da operação.', route: '/gestor' },
      { key: 'admin', label: 'Minha Igreja', description: 'Pessoas, eventos, escalas, relatórios e configurações locais.', route: '/admin' },
      { key: 'movimentos', label: 'Painel dos Movimentos', description: 'Famílias, missionários, grupos e acompanhamento regional.', route: '/movimentos-painel' },
    ];
  }
  if (role === 'admin') return [{ key: 'admin', label: 'Admin da Igreja', description: 'Painel administrativo local.', route: '/admin' }];
  if (role === 'auxiliar') return [{ key: 'auxiliar', label: 'Painel Auxiliar', description: 'Presenças, pessoas e escalas.', route: '/auxiliar' }];
  if (role === 'ebi_coordenadora') return [{ key: 'ebi', label: 'Portal EBI', description: 'Histórias, pessoas e grupos da EBI.', route: '/ebi' }];
  if (role === 'movimentos_coordenador') return [{ key: 'movimentos', label: 'Painel dos Movimentos', description: 'Famílias, missionários e grupos.', route: '/movimentos-painel' }];
  return [{ key: 'admin', label: 'Acessar sistema', description: 'Entrar no painel disponível.', route: '/admin' }];
};

export const getAccessOptions = (user) => {
  const options = Array.isArray(user?.access_options) && user.access_options.length > 0
    ? user.access_options
    : fallbackAccessOptions(user?.role);
  return options.filter(option => option?.route && option?.key);
};

export const rememberAccess = (option) => {
  if (!option?.key) return;
  localStorage.setItem(ACCESS_STORAGE_KEY, JSON.stringify({ key: option.key, route: option.route }));
};

export const getRememberedAccess = (options) => {
  try {
    const saved = JSON.parse(localStorage.getItem(ACCESS_STORAGE_KEY) || 'null');
    if (!saved?.key) return null;
    return options.find(option => option.key === saved.key) || null;
  } catch {
    return null;
  }
};

export const clearRememberedAccess = () => localStorage.removeItem(ACCESS_STORAGE_KEY);
